import { useEffect } from "react";
import { useLoading } from "../context/LoadingContext";

export default function useGlobalFetchLoading() {
  const { startLoading, stopLoading } = useLoading();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.fetch !== "function") return;
    if (window.__loadingFetchWrapped) return;

    const originalFetch = window.fetch;
    window.__loadingFetchWrapped = true;
    window.__originalFetch = originalFetch;

    window.fetch = async (...args) => {
      startLoading();
      try {
        return await originalFetch(...args);
      } finally {
        stopLoading();
      }
    };

    return () => {
      if (window.__loadingFetchWrapped && window.__originalFetch === originalFetch) {
        window.fetch = originalFetch;
        window.__loadingFetchWrapped = false;
      }
    };
  }, [startLoading, stopLoading]);
}
